module.exports = __webpack_public_path__ + "img/TabelleDownload.5aeece2e.png";